export default "__VITE_ASSET__BAywlRRi__"